/* Enrollment only. Rewards are fulfilled by verified server-side customer/consent workflows. */
if (!customElements.get('cysta-waitlist-form')) {
  customElements.define('cysta-waitlist-form', class extends HTMLElement {
    static normalizePhone(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length === 10 && /^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return '+1' + digits;
      if (digits.length === 11 && digits[0] === '1' && /^[2-9]\d{2}[2-9]\d{6}$/.test(digits.slice(1))) return '+' + digits;
      return null;
    }
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const emailForm = this.querySelector('.cysta-waitlist__form');
      const emailFields = this.querySelector('[data-waitlist-fields]');
      const smsForm = this.querySelector('[data-sms-form]');
      // Without a configured email provider, native Shopify submission handles validation and CAPTCHA.
      if (emailForm && emailFields && this.dataset.company && this.dataset.list) {
        emailForm.addEventListener('submit', (event) => this.submitEmail(event, emailForm));
      }
      if (smsForm && this.dataset.smsReady === 'true' && this.dataset.company && this.dataset.smsList) {
        smsForm.querySelector('fieldset').disabled = false;
        smsForm.addEventListener('submit', (event) => this.submitSms(event, smsForm));
      }
    }
    async subscribe(attributes, list, source) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.company), {
          method: 'POST', signal: controller.signal,
          headers: {accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-10-15'},
          body: JSON.stringify({data: {type: 'subscription', attributes: {custom_source: source, profile: {data: {type: 'profile', attributes}}}, relationships: {list: {data: {type: 'list', id: list}}}}})
        });
        if (response.status !== 202) throw new Error('Signup not accepted');
      } finally {
        clearTimeout(timeout);
      }
    }
    async submitEmail(event, form) {
      event.preventDefault();
      if (this.emailBusy || !form.reportValidity()) return;
      this.emailBusy = true;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-waitlist-status]');
      const original = button.innerHTML;
      const email = form.querySelector('[data-waitlist-email]').value.trim();
      button.disabled = true;
      button.textContent = 'Joining…';
      status.textContent = '';
      try {
        await this.subscribe({
          email,
          first_name: form.querySelector('[data-waitlist-name]').value.trim(),
          subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}},
          properties: {'Cysta launch campaign': 'launch-89-99-v1', 'Cysta email offer requested': true}
        }, this.dataset.list, 'Cysta launch email offer v1');
        form.querySelector('[data-waitlist-fields]').hidden = true;
        const confirmation = document.createElement('div');
        confirmation.className = 'cysta-waitlist__success';
        confirmation.setAttribute('role', 'status');
        confirmation.setAttribute('tabindex', '-1');
        confirmation.textContent = 'Request received. Confirm your email if asked. Your $9 first-kit offer will be sent when ordering opens.';
        form.append(confirmation);
        const smsStep = this.querySelector('[data-sms-step]');
        if (smsStep) {
          this.querySelector('[data-sms-email]').value = email;
          smsStep.hidden = false;
        }
        confirmation.focus();
      } catch (error) {
        status.textContent = 'We could not confirm your signup. Please try again or email info@trycysta.com.';
      } finally {
        this.emailBusy = false;
        button.disabled = false;
        button.innerHTML = original;
      }
    }
    async submitSms(event, form) {
      event.preventDefault();
      if (this.smsBusy || !form.reportValidity()) return;
      const status = form.querySelector('[data-sms-status]');
      const phoneInput = form.querySelector('[data-sms-phone]');
      const consent = form.querySelector('[data-sms-consent]');
      const phone = this.constructor.normalizePhone(phoneInput.value);
      if (!phone) {
        status.textContent = 'Enter a valid US mobile number, including its area code.';
        phoneInput.focus();
        return;
      }
      if (!consent.checked) {
        status.textContent = 'Please agree to marketing texts to request the optional text reward.';
        consent.focus();
        return;
      }
      this.smsBusy = true;
      const button = form.querySelector('button[type="submit"]');
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Sending…';
      status.textContent = '';
      try {
        await this.subscribe({
          email: form.querySelector('[data-sms-email]').value.trim(), phone_number: phone,
          subscriptions: {sms: {marketing: {consent: 'SUBSCRIBED'}}},
          properties: {'Cysta launch campaign': 'launch-89-99-v1', 'Cysta SMS offer requested': true}
        }, this.dataset.smsList, 'Cysta launch optional SMS offer v1');
        form.querySelector('fieldset').hidden = true;
        const confirmation = form.querySelector('[data-sms-success]');
        confirmation.textContent = 'One more step: confirm your number using the text you receive. Once confirmed, your offer is $9 off your first kit plus $11 off your second subscription order. These discounts apply to separate orders, not as a $20 first-order balance.';
        confirmation.hidden = false;
        confirmation.focus();
      } catch (error) {
        status.textContent = 'We could not confirm your text signup. Please retry. Your email signup is unchanged.';
      } finally {
        this.smsBusy = false;
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  });
}
